<div class="my-layout my-layout-blank" [@openClose]="isOpen ? true : false">
  <div class="my-layout-background"></div>
  <div class="my-layout-content">
    <router-outlet></router-outlet>
  </div>
</div>
